import * as React from "react";
import { Redirect, useHistory } from "react-router-dom";

import firebase from "firebase/app";

import { Typography } from "@material-ui/core";
import { Box, Button } from "@material-ui/core";

import { Page } from "Components/Pages/Page";
import { IPageProps } from "Components/Pages/IPageProps";

import { HomeRoute, LoginRoute } from "Routes";

export function AccountPage(props: IPageProps): React.ReactElement {
    const history = useHistory();

    if (props.user === undefined) {
        return <Redirect to={LoginRoute.path} />
    }

    const logOut = () => {
        firebase.auth().signOut();

        history.push(HomeRoute.path);
    };

    return (
        <Page>
            <Box mb={2}>
                <Typography variant="h5">Account Information</Typography>
            </Box>

            <Typography>Email: {props.user!.email}</Typography>

            <Box mt={2}>
                <Button variant="contained" onClick={logOut}>Log out</Button>
            </Box>
        </Page>
    );
}